const PBS_URL = 'pbs.org'
const DONATE_URL = 'https://www.pbs.org/donate'

const urls = {
  DONATE_URL,
  PBS_URL,
}

export default urls
